import * as actionTypes from './actionTypes';

export const storeTextBody = (payload) => ({ type: actionTypes.WIZARD_SET_TEXT_BODY_UPDATE, payload });

export const storeFiles = (payload) => ({ type: actionTypes.WIZARD_APPEND_FILES, payload });
export const storeSetFiles = (payload) => ({ type: actionTypes.WIZARD_SET_FILES, payload });
export const removeFile = (payload) => ({ type: actionTypes.WIZARD_REMOVE_FILE, payload });

export const storeCustoms = (payload) => ({ type: actionTypes.WIZARD_STORE_CUSTOMS, payload });
export const setStoreCustoms = (payload) => ({ type: actionTypes.WIZARD_SET_STORE_CUSTOMS, payload });

export const storeScheduleDate = (payload) => ({ type: actionTypes.WIZARD_STORE_SCHEDULE_DATE, payload });

export const storeTimeZone = (payload) => ({ type: actionTypes.WIZARD_STORE_TIMEZONE, payload });

export const storeCustomsSocialPage = (payload) => ({ type: actionTypes.WIZARD_SET_CUSTOMS_SOCIAL_PAGE, payload });

export const addCustomsFiles = (payload) => ({ type: actionTypes.WIZARD_ADD_CUSTOMS_FILES, payload });
export const removeCustomsFile = (payload) => ({ type: actionTypes.WIZARD_REMOVE_CUSTOMS_FILE, payload });
export const setCustomsText = (payload) => ({ type: actionTypes.WIZARD_SET_CUSTOMS_TEXT, payload });

export const storeCurrentCustomsId = (payload) => ({ type: actionTypes.WIZARD_UPDATE_ACTIVE_CUSTOMS, payload });

export const resetWizardState = () => ({ type: actionTypes.WIZARD_RESET_STATE });
